import { useTranslation } from 'react-i18next';

interface NoConsumptionDataProps {
  /** Tipo do medidor, usado para traduzir o rótulo (água/gás/energia). */
  meterType: 'water' | 'gas' | 'energy';
}

/**
 * Estado vazio calmo para quando a unidade genuinamente não tem medidor
 * desse tipo cadastrado (upstream responde 404 — não é uma falha, ver
 * ConsumptionDataController#fetch_consumption no api-customer).
 */
export function NoConsumptionData({ meterType }: NoConsumptionDataProps) {
  const { t } = useTranslation();

  const meterDefaults = { water: 'Água', gas: 'Gás', energy: 'Energia' };
  const meterLabel = t(`views.general.charts.type_${meterType}`, meterDefaults[meterType]).toLowerCase();

  return (
    <div className="w-full flex flex-col items-center justify-center text-center py-16 px-4">
      <div className="w-16 h-16 rounded-full bg-mist-100 flex items-center justify-center mb-4">
        <i className="fa fa-tachometer text-[28px] text-mist-500" aria-hidden="true"></i>
      </div>
      <h4 className="text-[#455a64] text-base font-medium mb-1">
        {t('views.consumption.no_data.title', 'Sem dados de consumo')}
      </h4>
      <p className="text-[#99abb4] text-sm max-w-[360px]">
        {t('views.consumption.no_data.text', {
          defaultValue: 'Ainda não encontramos um medidor de {{meter}} cadastrado para esta unidade.',
          meter: meterLabel,
        })}
      </p>
    </div>
  );
}
